/**
 * @file: DepartmentAiRule.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 食堂ai识别规则表
 */
import request from '@/utils/request'

/**
 * 删除规则(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptairuleDepartmentairuleDel(data) {
  return request({
    type: 'device',
    url: 'deptairule/departmentAiRule/del',
    method: 'post',
    data
  })
}

/**
 * 规则详情(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptairuleDepartmentairuleGet(data) {
  return request({
    type: 'device',
    url: 'deptairule/departmentAiRule/get',
    method: 'post',
    data
  })
}

/**
 * 规则管理列表(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptairuleDepartmentairuleList(data) {
  return request({
    type: 'device',
    url: 'deptairule/departmentAiRule/list',
    method: 'post',
    data
  })
}

/**
 * 新增/修改规则(ch)
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function deptairuleDepartmentairuleSave(data) {
  return request({
    type: 'device',
    url: 'deptairule/departmentAiRule/save',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/DepartmentAiRule.js